import React, { useState, useEffect, Fragment } from "react";
import { NavbarToggler, Label } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import MediaQuery from "react-responsive";
import { EnvironmentSign } from "bx-react-ui";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { getUserContext, getAuth } from "../../../reducers/selectors";
import { signOut } from "../../../actions/auth";
import menuLine from "../../../../public/svg/menu.svg";

import style from "./HeaderOnboarding.scss";

const environmentName = window.___APP_CONFIG___.ENV_NAME ? window.___APP_CONFIG___.ENV_NAME : "TESTING";

export const HeaderOnboarding = ({
  toggleMobileSidebar,
  AccountJSON,
  actions,
  username,
  isProdEnv,
  isTestingUser,
  title,
}) => {
  const showEnvironmentSign = !isProdEnv || isTestingUser;
  const environmentSignText = isProdEnv ? "PRODUCTION" : environmentName;
  const environmentSignColor = isProdEnv ? "red" : "#34784B";
  const dispatch = useDispatch();

  const context = useSelector(getUserContext);
  const [idleTimeout, setIdleTimeout] = useState(1);

  useEffect(() => {
    if (context !== null) {
      if (Object.keys(context)) {
        setIdleTimeout(context.session.MaxIdleSessionTime);
      }
    }
  }, [context]);

  // Don't delete - it controls the idle timer to logout session automatically
  const logoutTimer = useIdleTimer({
    timeout: idleTimeout * 60 * 1000,
    crossTab: true,
    syncTimers: 200,
    name: "logout-timer",
    onIdle: () => {
      dispatch(signOut());
      window.location.reload();
    },
  });

  return (
    <header className={`${style.appHeader} app-header navbar`} style={{ margin: "0 !important" }}>
      {/* <span className={style.hambMenuLogo}>
        <Fragment>
          <NavbarToggler
            className={`${style.navToggler} d-md-down-none`}
            onClick={(e) => {
              toggleMobileSidebar();
            }}
          >
            <img className={style.hambIcon} src={menuLine} alt="hamburger menu" />
          </NavbarToggler>
        </Fragment>
      </span> */}
      <MediaQuery maxWidth={576}>
        <img id={style.logo} src="/svg/SideBarIcons/full-logo-home-white.svg" alt="logo" />  
      </MediaQuery>
      <MediaQuery minWidth={576}>
        <Label className={style.headerTitle}>{title}</Label>
      </MediaQuery>
      <hr className={style.headerHr}></hr>
    </header>
  );
};
